import { Users } from '@platform/client';
import { GetCurrentUser200 } from '@platform/client/schemas';
import { useIdentifyHotjarUser } from '../../analytics/hotjar';
import { useIdentifyMixpanelUser } from '../../analytics/mixpanel';
import NextBestActions from '../next-best-actions';
import NextStepsSegment from './NextSteps/NextStepsSegment';
import SearchStatusIndicator from './SearchStatusIndicator';

/** The main content panel of the dashboard home page */
const DashboardHomePanel = () => {
  const { isSuccess, data: user } = Users.useGetCurrentUser({
    query: {
      // Throw an error if we fail to fetch user data after retries are complete
      // TODO: Find a more graceful way to error the frontend when we are unable to fetch core app data like this, outside of the Dashboard feature
      throwOnError: true,
    },
  });

  // App initialization logic to ID the current logged in user for our analytics tools
  // TODO: This logic should not live here, but it necessarily requires the user to be authed to function.
  // We need to move this into a global auth handler somewhere.
  useIdentifyMixpanelUser();
  useIdentifyHotjarUser();

  return (
    <div className='px-4 sm:pl-4 md:pl-0 w-full min-w-0 flex flex-col gap-4'>
      <div className='mx-auto max-w-[700px] w-full flex flex-col gap-4'>
        <div className='text-3xl'>Welcome back{isSuccess && `, ${user?.firstName} `}</div>
        {isSuccess && user?.accountType === 'experteer' && <SearchStatusIndicator />}
        {/* TODO: Check with Kelsey/Don; only f5, transform, or diverse suppliers have NBAs? See apps/legacy/templates/template_redesign/dashboard-organization/workspace-content/dashboard-home.jade */}
        <NextBestActions user={user as GetCurrentUser200} />
        <NextStepsSegment />
      </div>
    </div>
  );
};

export default DashboardHomePanel;
